import { render } from "./SaveDraft.vue?vue&type=template&id=5d48bed4&scoped=true"
import script from "./SaveDraft.vue?vue&type=script&lang=js"
export * from "./SaveDraft.vue?vue&type=script&lang=js"

import "./SaveDraft.vue?vue&type=style&index=0&id=5d48bed4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d48bed4"]])

export default __exports__